import { HubConnectionBuilder, HubConnection, HubConnectionState } from '@aspnet/signalR';

export default class WebSocket {

    connection: HubConnection | null;
    socketProxy: any;
    attemptingReconnect: boolean;
    reconnectTimer: any;

    constructor() {
        this.connection = null;
        this.socketProxy = null;
        this.attemptingReconnect = false;
        this.reconnectTimer = null;
    }

    InitializeConnection = (endpoint: any, jwt: string) => {
        let url = `${window.wsPath}${endpoint}`;
        this.connection = new HubConnectionBuilder().withUrl(url, { accessTokenFactory: () => jwt}).build();
        this.RegisterEvents(this.connection);
    }

    RegisterEvents = (connection: HubConnection) => {
        connection.onclose(this.HandleDisconnect);
    }

    HandleDisconnect = () => {
        // Base Http Connection handles reconnect logic, notify user from here if needed
        this.StartConnection();
    }

    StartConnection = () => {
        if (this.connection != null) {
            this.connection.start();
        }
    }

    StopConnection = () => {
        if (this.connection != null) {
            return this.connection.stop();
        }
    }
}